
























































































































import Vue from 'vue';
import AddAdminBox from '../components/common/AddAdminBox.vue';
import AddRightsBox from '../components/common/AddRightsBox.vue';
import UpdateSuperAdminBox from '../components/common/UpdateSuperAdminBox.vue';
import massVuex from '../vuex/common';
import massClient from '../apis';
import RiskBox from 'common/components/ui/RiskBox/index.vue';
import { MASS } from '@/mass/models/Mass';
import Customer from '@/customer/models/Customer';

const admin: object | null = null;
const superAdmin: object | null = null;

export default Vue.extend({
  mixins: [massVuex],
  components: {
    AddAdminBox,
    RiskBox,
    AddRightsBox,
    UpdateSuperAdminBox,
  },
  data() {
    return  {
      MASS,
      showAddAdminBox: false,
      current: 1,
      total: 0,
      pageSize: 20,
      loadAdminFinished: false,
      admins: [],
      checked: true,
      hoverIndex: -1,
      showRemoveAdminBox: false,
      showAddRightsBox: false,
      showUpdateSuperAdminBox: false,
      rights: MASS.RIGHTS.BROADCAST,
      admin,
      superAdmin,
      hadUpdateSuperIng: false,
      defaultNickname: '未知用户',
      defaultAvatar: '',
      loaded: false,
    };
  },
  methods: {
    insertRights(e: any, customer: any, rights: string) {
      e.preventDefault();
      if (this.checkRightsSum(rights) >= 3) {
        this.$Message.error('最多设置三位管理员');
      } else {
        this.rights = rights;
        this.admin = customer;
        this.showAddRightsBox = true;
      }
    },
    checkRights(admin: any, type: number) {
      let status = false;
      switch (type) {
        case MASS.RIGHTS_TYPE.MASS:
          status = admin.status.filter((s: any) => s.status === 0 && s.applyType === MASS.RIGHTS_TYPE.MASS && s.openid === admin.helperAuth.openid).length > 0;
          break;
        case MASS.RIGHTS_TYPE.REPLACE_SUPER:
          status = admin.status.filter((s: any) => s.status === 0 && s.applyType === MASS.RIGHTS_TYPE.REPLACE_SUPER && s.openid === admin.helperAuth.openid).length > 0;
          if (status) {
            this.hadUpdateSuperIng = true;
          }
          break;
        case MASS.RIGHTS_TYPE.BROADCAST:
          status = admin.status.filter((s: any) => s.status === 0 && s.applyType === MASS.RIGHTS_TYPE.BROADCAST && s.openid === admin.helperAuth.openid).length > 0;
          break;
        case MASS.RIGHTS_TYPE.TEMPLATE_SEND:
          status = admin.status.filter((s: any) => s.status === 0 && s.applyType === MASS.RIGHTS_TYPE.TEMPLATE_SEND && s.openid === admin.helperAuth.openid).length > 0;
          break;
        case MASS.RIGHTS_TYPE.SMS:
          status = admin.status.filter((s: any) => s.status === 0 && s.applyType === MASS.RIGHTS_TYPE.SMS && s.openid === admin.helperAuth.openid).length > 0;
          break;
        default:
          break;
      }
      return status;
    },
    checkRightsSum(rights: string) {
      let sum = 0;
      switch (rights) {
        case MASS.RIGHTS.BROADCAST:
          sum = this.admins.filter((h: any) => h.helperRights && h.helperRights.broadcasts && h.status === 0).length;
          break;
        case MASS.RIGHTS.MASS:
          sum = this.admins.filter((h: any) => h.helperRights && h.helperRights.broadcast && h.status === 0).length;
          break;
        case MASS.RIGHTS.SMS:
          sum = this.admins.filter((h: any) => h.helperRights && h.helperRights.sms && h.status === 0).length;
          break;
        case MASS.RIGHTS.TEMPLATE_SEND:
          sum = this.admins.filter((h: any) => h.helperRights && h.helperRights.templateSend && h.status === 0).length;
          break;
        default:
          break;
      }
      return sum;
    },
    loadAdmin() {
      this.loadAdminFinished = false;
      massClient.getAdmin({
        page: this.current,
        size: this.pageSize,
      }).success((r) => {
        this.admins = r.data;
        this.total = r.total;
        const superAdmins = this.admins.filter((a: any) => a.helperAuth.isSuper).map((a: any) => a.customer);
        if (superAdmins) {
          this.superAdmin = superAdmins[0];
        }
        this.loadAdminFinished = true;
      });
    },
    setSuper(admin: any) {
      if (this.hadUpdateSuperIng) {
        this.$Message.warning('已有主管理员更换申请，请等待审核结果');
      } else {
        if (this.admins.filter((a: any) => a.helperAuth.isSuper)) {
          this.admin = admin.customer;
          this.showUpdateSuperAdminBox = true;
        } else {
          massClient.setSuper({
            openid: admin.customer.openid,
          }).success((r) => {
            if (r.code === 0) {
              this.$Message.success('设置成功');
            } else {
              this.$Message.error('设置失败，请刷新页面重试');
            }
            this.loadAdmin();
          });
        }
      }
    },
    addRightsAfter() {
      this.showAddRightsBox = false;
      this.loadAdmin();
    },
    confirmRemove(admin: any) {
      massClient.removeAuth({
        openid: admin.helperAuth.openid,
      }).success((r) => {
        if (r) {
          this.$Message.success('解绑成功');
        } else {
          this.$Message.error('解绑失败，请刷新页面重试');
        }
        this.loadAdmin();
      });
      this.showRemoveAdminBox = false;
    },
    confirmUpdateSuper() {
      this.showUpdateSuperAdminBox = false;
      this.loadAdmin();
    },
    successAfter() {
      this.showAddAdminBox = false;
      this.loadAdmin();
    },
    getImgUrl(customer: Customer) {
      if (customer) {
        return customer.wxProps.headimgurl.replace('http://', 'https://');
      } else {
        return this.defaultAvatar;
      }
    },
    getNickname(customer: Customer) {
      if (customer) {
        return customer.wxProps.nickname;
      } else {
        return this.defaultNickname;
      }
    },
    hoverSet(index: number) {
      if (!this.showRemoveAdminBox) {
        this.hoverIndex = index;
      }
    },
  },
  mounted() {
    this.loadAdmin();
  },
});
